import { useEffect, useState } from "react";
import { getPublishedSubmissions } from "@/lib/publishedProperties";

export const usePublishedProperties = () => {
  const [publishedProperties, setPublishedProperties] = useState([]);

  useEffect(() => {
    let isMounted = true;

    getPublishedSubmissions()
      .then((rows) => {
        if (isMounted) setPublishedProperties(rows);
      })
      .catch((error) => {
        console.log("No se pudieron cargar propiedades publicadas:", error);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return publishedProperties;
};
